<template>
    <div class="channel-code">
        <div class="header">
            <div class="left">
                <label>公众号名称</label>
                <el-input placeholder="请输入公众号名称" v-model="appName" @keyup.enter.native="pageChange(1)"></el-input>
                <label>渠道名</label>
                <el-input placeholder="请输入渠道名" v-model="channel" @keyup.enter.native="pageChange(1)"></el-input>
                <el-button class="add" type="warning" @click="pageChange(1)">查询</el-button>
            </div>
            <div class="right">
                <el-button class="add" type="warning" @click="openModel()">新增渠道二维码</el-button>
            </div>
        </div>
        <div class="body">
            <div class="page-title">二维码管理列表</div>
            <el-table :data="tableData" border class="omtable" style="width: 100%">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="appName" label="公众号名称"></el-table-column>
                <el-table-column prop="channel" label="渠道名"></el-table-column>
                <el-table-column prop="channelCode" label="渠道编号"></el-table-column>
                <el-table-column prop="addedSum" label="累计关注数"></el-table-column>
                <el-table-column prop="currentSum" label="当前关注数"></el-table-column>
                <el-table-column prop="unfollowSum" label="取消关注数"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="350px">
                    <template slot-scope="scope">
                        <el-button type="warning" size="small" @click="downloadImg(scope.row)">下载</el-button>
                        <el-button type="success" size="small" @click="goDetailPage(scope.row)">查看关注数据</el-button>
                        <el-button type="primary" size="small" @click="openModel(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small" @click="delData(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page"  background layout="total,prev, pager, next" @current-change="pageChange" :page-size='10' :total="listCount">
            </el-pagination>
        </div>
        <el-dialog :title="form.id?'编辑渠道二维码':'新增渠道二维码'" width="500px" :visible.sync="formShow">
            <el-form :model="form" label-width="90px" ref='form' label-position="right">
                <el-form-item label="公众号" v-if="form.id">
                    <el-input :disabled="true" v-model="form.appName"></el-input>
                </el-form-item>
                <el-form-item label="公众号" prop="subscriptionId" :rules="[rules.required('请选择公众号')]" v-else>
                    <el-select v-model="form.subscriptionId" placeholder="请选择公众号" :disabled="form.id?true:false">
                        <el-option
                            v-for="item in weChatList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道编号" v-if="form.id">
                    <el-input :disabled="true" v-model="form.channelCode"></el-input>
                </el-form-item>
                <el-form-item label="渠道名称" prop="channel" :rules="[rules.required('请输入渠道名称')]">
                    <el-input placeholder="请输入渠道名称" v-model="form.channel"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-list">
                <el-button type="warning" plain @click="formShow=false">取消</el-button>
                <el-button type="warning" @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import commom from "../../api/common";
import {ruleTool} from '@/api/mixins'
//当前实例组件
export default {
    mixins: [ruleTool],
    data: () => ({
        userId:"",
        appName:"",
        channel:"",
        listCount:0,
        tableData:[],
        pageNum:1,
        weChatList:[],//公众号列表
        form:{},
        formShow:false
    }),
    components: {},
    mounted() {
        this.userId = this.$tools.getLocal("userinfo").id
        this.getList();
    },
    methods: {
        goDetailPage(item){
            this.$router.push({
                path:'/weChat/follow',
                query:{
                    id:item.id,
                    appName:item.appName,
                    channel:item.channel,
                }
            })
        },
        downloadImg(item){
            this.$tools.downloadImg(this.$config.api_root+ "/api/bplat/transformImgUrl?imgUrl="+item.localQrcodeUrl);
        },
        // 提交表单
        submit(){
            this.$refs.form.validate((valid) => {
                if (valid) {

                    if(!this.form.channelCode){
                        this.form.channelCode = new Date().getTime();
                    }
                    this.form.userId = this.userId;
                    this.$http({
                        url:'/wechatthirdplat/subscriptionQrcode',
                        type:'post',
                        params: this.form,
                    }).then((data)=> {
                        this.formShow = false;
                        if(this.form.id){
                            this.$message.success('修改成功');
                        }else{
                            this.$message.success('添加成功');
                        }
                        this.pageChange(1);
                    })
                } else {
                    this.$message.error('请选择公众号');
                }
            });
        },
        // 打开表单弹窗
        openModel(item){
            if(item&&item.id){
                this.form = Object.assign({}, item);
                this.formShow = true;
                return;
            }
            const params = {
                userId:this.userId,
                pageSize:99,
                pageNum:1
            }
            this.$http({
                url:'/wechatthirdplat/subscription/read/list',
                type:'put',
                params: params,
            }).then((data)=> {
                this.weChatList = data.data;
                this.formShow = true;
                if(item){
                    item.subscriptionId = item.subscriptionId.toString();
                    this.form = Object.assign({}, item);
                }else{
                    this.form = {};
                }

            })
        },
        delData(item){
            this.$confirm(
                '确认删除二维码？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            .then(()=> {
                this.$http({
                    url:'/wechatthirdplat/subscriptionQrcode',
                    type:'delete',
                    params: {ids:item.id},
                }).then((data)=> {
                    this.pageNum = 1;
                    this.getList();
                    this.$message.success('删除成功');
                })
            });
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            const params = {
                userId:this.userId,
                appName:this.appName,
                channel:this.channel,
                pageSize:10,
                pageNum:this.pageNum
            }
            this.$http({
                url:'/wechatthirdplat/subscriptionQrcode/read/list',
                type:'post',
                params: params,
            }).then((data)=> {
                data.data.forEach(item =>{
                    if(!item.addedSum){
                        item.addedSum = "0";
                    }
                    if(!item.currentSum){
                        item.currentSum = "0";
                    }
                    if(!item.unfollowSum){
                        item.unfollowSum = "0";
                    }
                })
                this.tableData = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./channelCode";
</style>
